module.exports = "data:image/gif;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJzdGF0aWMvaW1nL3dlY2hhdENpcmNsZS5lNzJkMGE0LmdpZiI7DQoNCg0KLy8vLy8vLy8vLy8vLy8vLy8vDQovLyBXRUJQQUNLIEZPT1RFUg0KLy8gLi9zcmMvYXNzZXRzL2ltYWdlcy93ZWNoYXRDaXJjbGUuZ2lmDQovLyBtb2R1bGUgaWQgPSBUQVdrDQovLyBtb2R1bGUgY2h1bmtzID0gMjU="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wechatCircle.gif
// module id = TAWk
// module chunks = 49